import {routesPosition, RoutesProps} from "../router.config";
import Kanban, {KanbanColumn} from "../../components/Kanban/Kanban";
import ShipmentKanbanCard from "../../components/app/App/shipment-kanban-card";
import {ColumnImportConstants} from "../../constants/model";
import ImportType from "../../forms/app/types/import-type";
import {Roles} from "../../model/Group";
import {TicketNormalizer} from "../../services/normalizer/ticketNormalizer";
import FilterController from "../../components/FilterController";
import KanbanFilter from "../../forms/app/filters/kanban-filter";
import {Ticket} from "../../model/Ticket";
import AccessControl from "../../components/access-control";

interface OrderByDateOptions {
    resetTime: boolean
}

const columnOrderByDate = (
    aDate: [string, Date | null],
    bDate: [string, Date | null],
    options?: OrderByDateOptions
): number => {
    const [, aLoadingDate] = aDate;
    const [, bLoadingDate] = bDate;

    if (options && options.resetTime) {
        aLoadingDate?.setHours(0, 0, 0, 0);
        bLoadingDate?.setHours(0, 0, 0, 0);
    }

    if (aLoadingDate === null) {
        return 1;
    }
    if (bLoadingDate === null) {
        return -1;
    }

    // le +(Date) permet de cast en number la date (Timestamp) pour faire la comparaison
    return (+aLoadingDate - +bLoadingDate);
}

const columns: KanbanColumn<Ticket>[] = [
    {label: 'Nouveau Dr', col: ColumnImportConstants.NEW_CASE},
    {
        label: 'FOB',
        col: ColumnImportConstants.LOADING,
        orderBy: {departureDate: 'ASC'},
        localOrderBy: (a, b) => {
            return columnOrderByDate(
                a.shipment.displayedLoadingDate,
                b.shipment.displayedLoadingDate
            );
        },
    },
    {
        label: 'Arrivée',
        col: ColumnImportConstants.ARRIVAL,
        orderBy: {arrivalDate: 'ASC'},
        localOrderBy: (a, b) => {
            return columnOrderByDate(
                a.shipment.ATA ? a.shipment.displayedUnloadingDate : a.shipment.orderedUnloadingDate,
                b.shipment.ATA ? b.shipment.displayedUnloadingDate : b.shipment.orderedUnloadingDate,
                {resetTime: true}
            );

        }
    },
    {label: 'Douane', col: ColumnImportConstants.CUSTOMS},
    {label: 'Transport', col: ColumnImportConstants.TRANSPORT},
    {label: 'Facturation', col: ColumnImportConstants.BILLING},
];

export const importRoutes: RoutesProps = {
    icon: 'fas fa-plane-arrival',
    name: 'Import',
    path: '/import/',
    position: routesPosition.leftSideBar,
    handle: {
        crumb: 'Import',
    },
    accessControl: [Roles.ROLE_WORKFLOW_IMPORT_SHOW, Roles.ROLE_SUPER_ADMIN],
    children: [
        {
            path: '/import/',
            element: <AccessControl roles={[Roles.ROLE_WORKFLOW_IMPORT_SHOW, Roles.ROLE_SUPER_ADMIN]}>
                <FilterController
                    renderFilterable={(props) => <Kanban
                        {...props}
                        renderCard={(ticket) => <ShipmentKanbanCard ticket={ticket}/>}
                        columns={columns}
                        colSize={2}
                        namespace={'workflow_tickets'}
                        normalizer={TicketNormalizer}
                        getDoubleClickUrl={(ticket) => `/import/${ticket.id}`}
                    />}
                    filterDefault={{category: 'import', 'shipment+archived': false, managedByMe: true}}
                    renderFilter={(props) => <KanbanFilter {...props} />}
                />
            </AccessControl>,
            position: routesPosition.hiddenRoutes
        },
        {
            path: '/import/:id',
            element: <ImportType/>,
            handle: {
                crumb: 'Dossier',
            },
            position: routesPosition.hiddenRoutes,
        }
    ]
};
